<sf-notification></sf-notification>

<div class="formgrid grid text-lg dashboard">

    <div class="surface-section col-12 ">
        <div class="flex flex-column lg:flex-row gap-3 justify-content-between lg:align-items-center border-primary p-3 w-full" style="border-top: 7px solid;">
            <div class="flex flex-column gap-2 col-12 md:col-12 lg:col-6 p-3">
                <div class="flex align-items-center gap-2">
                    <h1 class="m-0 font-semibold text-900 text-3xl line-height-3">Painel do Cliente</h1>
                </div>
                <p class="mb-0 mt-0 text-base text-600 text-lg">Acompanhe os pedidos, mensagens e notificações com acesso rápido e fácil.</p>
            </div>
            <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 p-3">
                <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer" style="border-radius: 10px" (click)="newService()">
                    <div class="flex align-items-center mb-2">
                        <div class="mr-3">
                            <span class="inline-flex justify-content-center align-items-center bg-green-100" style="border-radius: 4px; width:45px; height: 45px">
                                <i class="pi pi-plus-circle text-2xl text-green-600" style="font-size: 1.5rem"></i>
                            </span>
                        </div>
                        <span class="text-900 text-2xl mb-1 font-bold">Novo Pedido</span>
                    </div>
                    <p class="text-600 m-0 line-height-3">Solicitar novo pedido de atendimento.</p>
                </div>
            </div>
            <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 p-3">
                <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer" style="border-radius: 10px" (click)="myServices()">
                    <div class="flex align-items-center mb-2">
                        <div class="mr-3">
                            <span class="inline-flex justify-content-center align-items-center bg-blue-100" style="border-radius: 4px; width:45px; height: 45px">
                                <i class="pi pi-file-edit text-2xl text-blue-600" style="font-size: 1.5rem"></i>
                            </span>
                        </div>
                            <span class="text-900 text-2xl mb-1 font-bold">Meus Pedidos</span>
                    </div>
                    <p class="text-600 m-0 line-height-3">Consultar e atualizar pedidos.</p>
                </div>
            </div>
        </div>
    </div>
            <!-- <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 p-3">
                <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer" style="border-radius: 10px" (click)="newService()">
                    <div class="flex align-items-center mb-2">
                        <div class="mr-3">
                            <span class="inline-flex justify-content-center align-items-center bg-green-100" style="border-radius: 4px; width:45px; height: 45px">
                                <i class="pi pi-plus-circle text-2xl text-green-600" style="font-size: 1.5rem"></i>
                            </span>
                        </div>
                        <span class="text-900 text-2xl mb-1 font-bold">Novo Pedido</span>
                    </div>
                    <p class="text-600 m-0 line-height-3">Solicitar novo pedido de atendimento.</p>
                </div>
            </div>
            <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 p-3">
                <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer" style="border-radius: 10px" (click)="myServices()">
                    <div class="flex align-items-center mb-2">
                        <div class="mr-3">
                            <span class="inline-flex justify-content-center align-items-center bg-blue-100" style="border-radius: 4px; width:45px; height: 45px">
                                <i class="pi pi-file-edit text-2xl text-blue-600" style="font-size: 1.5rem"></i>
                            </span>
                        </div>
                            <span class="text-900 text-2xl mb-1 font-bold">Meus Pedidos</span>
                    </div>
                    <p class="text-600 m-0 line-height-3">Consultar e atualizar pedidos.</p>
                </div>
            </div>
        </div>
    </div> -->



    <div class="col-12 md:col-12 lg:col-6 xl:col-6 mt-2">
        <div class="surface-card shadow-2 border-round p-4">
            <div class="flex justify-content-between align-items-center mb-5 w-full">
                <ul class="surface-card p-0 m-0 list-none flex overflow-x-auto select-none w-full text-xl">
                    <li class="flex-1">
                        <a pRipple class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150"
                            [ngClass]="{'border-blue-500 text-blue-700 hover:border-blue-500': activeOrder === 0, 'text-900 border-transparent': activeOrder !== 0}" (click)="changeOrder(0)">
                            <i class="pi pi-home mr-2"></i>
                            <span class="text-xl">Pedidos Em Execução</span>
                        </a>
                    </li>
                    <li class="flex-1">
                        <a pRipple class="cursor-pointer px-4 py-3 flex align-items-center justify-content-center border-bottom-2 hover:border-500 transition-colors transition-duration-150"
                        [ngClass]="{'border-blue-500 text-blue-700 hover:border-blue-500': activeOrder === 1, 'text-900 border-transparent': activeOrder !== 1}" (click)="changeOrder(1)">
                            <i class="pi pi-users mr-2"></i>
                            <span class="text-xl">Pedidos Encerrados</span>
                        </a>
                    </li>
                </ul>
            </div>
            <p-scrollPanel [style]="{ width: '100%', height: screenHeightOrder }">
                <ul class="list-none p-0 m-0">
                    <div *ngIf="activeOrder == 0">
                        <ng-container *ngFor="let order of orderListOpened; let i = index">
                            <a pRipple class="cursor-pointer" [routerLink]="['/order/detail/', order.id]">
                                <li class="flex flex-column md:flex-row md:align-items-center md:justify-content-between p-3 border-1 mb-3 bg-{{order.classColor}}-50 border-{{order.classColor}}-500" style="border-radius: 10px;">
                                    <div>
                                        <div>
                                            <span class="inline-flex justify-content-center align-items-center w-2rem h-2rem border-circle border-1 border-{{order.classColor}}-200">
                                                <i class="pi pi-building-columns text-{{order.classColor}}-600"></i>
                                            </span>
                                            <span class="text-{{order.classColor}}-700 text-xl ml-2">{{order.companyName}}</span>
                                        </div>
                                        <p class="text-{{order.classColor}}-700 mt-2 mb-0 font-bold">Pedido: #{{order.code}} <span class="font-bold">{{order.description}}</span></p>
                                        <p class="text-{{order.classColor}}-700 mt-2 mb-0">Data: <span class="font-medium">{{order.statusDate | date: 'dd/MM/yyyy'}}</span></p>
                                    </div>
                                    <div class="flex align-items-center justify-content-between md:justify-content-end mt-3 md:mt-0">
                                        <div class="text-right ml-3">
                                            <p class="bg-{{order.classColor}}-300 text-{{order.classColor}}-900 font-bold text-sm py-1 px-2" style="border-radius: 10px">{{order.statusName}}</p>
                                            <p class="text-{{order.classColor}}-700 font-bold text-2xl mb-3">{{order.totalValue | currency: 'BRL'}}</p>

                                            <!-- <p class="mt-1 mb-0 text-green-700">EUR</p> -->
                                        </div>
                                    </div>
                                </li>
                            </a>
                        </ng-container>
                    </div>
                    <div *ngIf="activeOrder == 1">
                        <ng-container *ngFor="let order of orderListClosed; let i = index">
                            <a pRipple class="cursor-pointer" [routerLink]="['/order/detail/', order.id]">
                                <li class="flex flex-column md:flex-row md:align-items-center md:justify-content-between p-3 border-1 mb-3 bg-{{order.classColor}}-50 border-{{order.classColor}}-500" style="border-radius: 10px;">
                                    <div>
                                        <div>
                                            <span class="inline-flex justify-content-center align-items-center w-2rem h-2rem border-circle border-1 border-{{order.classColor}}-200">
                                                <i class="pi pi-building-columns text-{{order.classColor}}-600"></i>
                                            </span>
                                            <span class="text-{{order.classColor}}-700 text-xl ml-2">{{order.companyName}}</span>
                                        </div>
                                        <p class="text-{{order.classColor}}-700 mt-2 mb-0 font-bold">Pedido: #{{order.code}} <span class="font-bold">{{order.description}}</span></p>
                                        <p class="text-{{order.classColor}}-700 mt-2 mb-0">Data: <span class="font-medium">{{order.statusDate | date: 'dd/MM/yyyy'}}</span></p>
                                    </div>
                                    <div class="flex align-items-center justify-content-between md:justify-content-end mt-3 md:mt-0">
                                        <div class="text-right ml-3">
                                            <p class="bg-{{order.classColor}}-300 text-{{order.classColor}}-900 font-bold text-sm py-1 px-2" style="border-radius: 10px">{{order.statusName}}</p>
                                            <p class="text-{{order.classColor}}-700 font-bold text-2xl mb-3">{{order.totalValue | currency: 'BRL'}}</p>

                                            <!-- <p class="mt-1 mb-0 text-green-700">EUR</p> -->
                                        </div>
                                    </div>
                                </li>
                            </a>
                        </ng-container>
                    </div>
                </ul>
            </p-scrollPanel>
        </div>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-6 mt-2" >

        <p-card styleClass="chat" [style]="{'height': '100%'}" header="Menssagens e Notificações">
            <p-scrollPanel [style]="{ width: '100%', height: screenHeightChat }">
                <!-- <ng-container *ngFor="let chat of chatList; let i = index">
                            <ul>
                                <div *ngIf="chat.sourceUserId != userId">
                                    <li class="message-from">
                                        <div class="message-meta">
                                            <p-avatar [label]="getInitials(chat.sourceUserName)" [style]="{ 'background-color': AVATAR_COLOR_FROM, 'color': 'white', 'font-weight': 'bold' }" ></p-avatar>
                                            <span class="name ml-2">{{chat.sourceUserName}}</span>
                                            <span class="time">{{chat.dateOfRegistration | date: 'dd/MM/yyyy HH:mm'}}</span>

                                            <button pButton pRipple icon="pi pi-comment"
                                                class="text-xl font-semibold btn-action mt-2" size="large" style="font-size: 10px !important;"
                                                [label]="'message.new_message' | translate" (click)="openDialogSendMessage(chat.woOrderId);">
                                            </button>
                                        </div>
                                        <div class="message">
                                            <span><label [innerHtml]="chat.message"></label></span>
                                        </div>
                                    </li>
                                </div>
                                <div *ngIf="chat.sourceUserId == userId">
                                    <li class="message-own">
                                        <div class="message">
                                            <span><label [innerHtml]="chat.message"></label></span>
                                        </div>
                                        <div class="message-meta">
                                            <p-avatar [label]="getInitials(chat.sourceUserName)" [style]="{ 'background-color': AVATAR_COLOR_OWN, 'color': 'white', 'font-weight': 'bold' }" ></p-avatar>
                                            <span class="name ml-2">{{chat.sourceUserName}}</span>
                                            <span class="time">{{chat.dateOfRegistration | date: 'dd/MM/yyyy HH:mm'}}</span>
                                        </div>
                                    </li>
                                </div> -->

                <!-- <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li>
                                <li class="message-from">
                                    <div class="message-meta">
                                        <img src="assets/layout/images/avatar-dani.png" alt="california-layout" />
                                        <span class="name">Dani Daniel</span>
                                        <span class="time">21 mins ago</span>
                                    </div>
                                    <div class="message">
                                        <span>OK! That sounds great. 👍 </span>
                                    </div>
                                </li> -->
                <!-- </ul>
                        </ng-container> -->

                <app-sc-user-message-chat></app-sc-user-message-chat>

            </p-scrollPanel>
            <!-- <div class="write-message">
                            <i class="pi pi-paperclip"></i>
                            <input type="text" />
                        </div> -->
        </p-card>
    </div>

    <p-dialog *ngIf="displaySendMessage" [(visible)]="displaySendMessage" [style]="{ height:'400px', width: '600px' }"
        [contentStyle]="{'overflow-y': 'none'}" [header]="dialogHeaderSendMessage" [modal]="true" styleClass="fluid">
        <app-sc-user-message-send [woOrder]="woOrder" [clientName]="woOrder.clientName" [userName]="woOrder.userName"
            (chosedItem)="displaySendMessage = false">
        </app-sc-user-message-send>
    </p-dialog>
